<template>
<div
  id="tag-select"
  class="form-group"
>
  <div
    v-if="!loading"
  >
    <h4
      v-if="!noHeader"
    >
      Select Tags
      <router-link
        :to="{
          name: 'create_tag'
        }"
        class="btn btn-primary btn-sm"
        v-if="!hideCreate"
      >
        Create New Tag
      </router-link>
    </h4>

    <div
      v-if="!tags.length"
    >
      No tags available.
    </div>
    <div v-else>
      <div
        v-if="noButtons"
      >
        <div
          class="form-group"
        >
          <select
            class="form-control"
            :name="type"
            multiple
          >
            <option
              v-for="tag in tags"
              v-bind:key="tag.id"
              :value="tag.id"
              :selected="tagSelected(tag)"
            >
              {{ tag.name }}
            </option>
          </select>
        </div>
      </div>
      <div
        v-else
      >
        <button
          v-for="tag in tags"
          v-bind:key="tag.id"
          :class="tagClass(tag)"
          :data-tag-id="tag.id"
          :data-tag-slug="tag.slug"
          :data-tag-selected="tagSelected"
          v-on:click.prevent="tagToggled"
        >
          {{ tag.name }}

          <input
            type="hidden"
            :name="selectInputName"
            :value="tag.id"
            v-if="tagSelected(tag)"
          />

          <input
            type="hidden"
            :name="tagAttributesName"
            :value="tag.id"
            v-if="!tagSelected(tag)"
          />
        </button>
      </div>
    </div>
  </div>
  <div
    v-else
  >
    <spinner
      size="huge"
    />
  </div>
</div>
</template>
<script>
import TagMixin from '@/mixins/TagMixin'

import TagsStore from '@/stores/TagsStore'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    let state = TagsStore.state
    state.loading = false

    return state
  },

  props: {
    'hideCreate': {
      type: Boolean,
      default: false
    },

    'noButtons': {
      type: Boolean,
      default: false
    },

    'noHeader': {
      type: Boolean,
      default: false
    },

    'type': {
      type: String,
      default: undefined
    },

    /*
      Allows for destroying tags by including tag relationship IDs.
    */
    'resourceTags': {
      type: Array,
      default: () => {
        return []
      }
    },

    'selectedTagIds': {
      type: Array,
      default: () => {
        return []
      }
    },

    'selectedTags': {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  computed: {
    selectInputName () {
      return this.type ? (
        this.type + '[tag_ids][]'
      ) : 'tag_ids[]'
    },

    selectedIds () {
      return this.selectedTags.map((selectedTag) => {
        const filteredTags = this.tags.filter((tag) => tag.slug === selectedTag)[0].id

        return filteredTags
      })
    },

    tagAttributesName () {
      return this.type + '_tags_attributes[]'
    }
  },

  mixins: [ TagMixin ],

  components: {
    'spinner': Spinner
  },

  created () {
    this.get()
  },

  methods: {
    get () {
      this.loading = true
      this.apiGet('/tags?page[size]=500&imported=false', undefined, true).then((resp) => {
        this.loading = false
        this.tags = resp
        this.tags.sort(this.sortByName)
      })
    },

    inputTagName () {
      return (this.type ? (this.type + '_') : '') + 'tag_ids[]'
    },

    sortByName (a, b) {
      let nameA = a.name.toUpperCase()
      let nameB = b.name.toUpperCase()
      if (nameA < nameB) {
        return -1
      }

      if (nameA > nameB) {
        return 1
      }

      return 0
    },

    tagClass (tag) {
      return 'btn tag ' + (
        this.tagSelected(tag) ? 'btn-primary tag-selected' : 'btn-outline-primary tag-unselected'
      )
    },

    tagSelected (tag) {
      if (this.selectedTags.length) {
        return (this.selectedTags.indexOf(tag.slug) >= 0)
      } else if (this.selectedTagIds.length) {
        return this.selectedTagIds.includes(tag.id)
      }
    },

    tagToggled (ev) {
      const target = ev.target
      const tagId = target.dataset.tagId
      const slug = target.dataset.tagSlug

      const selected = this.tagSelected(slug)
      const emitName = selected ? 'tagRemoved' : 'tagAdded'

      this.$parent.$emit(emitName, {
        id: tagId,
        slug: slug
      })

      target.blur()
    }
  }
}
</script>

<style scoped>
.tag {
  margin-right: 1em
}

.tag:hover {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/components/TagSelect.vue